exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".restricted-user-group-tooltip{max-width:50% !important;word-break:break-all;white-space:normal}", ""]);

// exports
